module.exports = __webpack_public_path__ + "img/329-44ef20.png";